import { createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0fe91f26")

_pushScopeId("data-v-0fe91f26")
const _hoisted_1 = { class: "detail-dish-item" }
const _hoisted_2 = { class: "detail-dish-item-title-view-area" }
const _hoisted_3 = { class: "detail-dish-item-cooking-tool-view-area" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "detail-dish-item-text" }, "(", -1)
const _hoisted_5 = { class: "detail-dish-item-cooking-tool-text" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "detail-dish-item-text" }, "を使用)", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DetailIngredientItem = _resolveComponent("DetailIngredientItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "detail-dish-item-title-view",
        innerHTML: _ctx.title
      }, null, 8, ["innerHTML"]),
      _withDirectives(_createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, _toDisplayString(_ctx.cookingTool), 1),
        _hoisted_6
      ], 512), [
        [_vShow, _ctx.isShowCookingTool()]
      ])
    ]),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getIngredients(), (item) => {
      return (_openBlock(), _createBlock(_component_DetailIngredientItem, {
        key: item.id,
        description: item.ingredient.description,
        quantity: item.ingredient.quantityText,
        ingredient: item.ingredient,
        isBottom: item.bottom,
        isTop: item.top
      }, null, 8, ["description", "quantity", "ingredient", "isBottom", "isTop"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
})